import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import "./SearchField.scss";

function SearchField({ searchQuery, setQuery, isSearchVisible = true, setIsSearchVisible }) {
  const colorMode = useSelector((state) => state.ui.colorMode);
  const searchInputRef = useRef(null);

  const handleClear = () => {
    setQuery("");
    if (setIsSearchVisible) setIsSearchVisible(false);
  };

  useEffect(() => {
    if (isSearchVisible && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isSearchVisible]);

  return (
    <form className="searchField" onSubmit={(e) => e.preventDefault()}>
      <input
        ref={searchInputRef}
        type="search"
        placeholder="Search by color or theme..."
        className={`search-input ${searchQuery ? "hasText" : ""}`}
        value={searchQuery}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onChange={(e) => setQuery(e.target.value)}
        enterKeyHint="search"
      />
      {searchQuery && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleClear();
          }}
          className={`clear-button ${colorMode}`}
          aria-label="Clear search"
        />
      )}
      {/* <button type="submit" className={`search-button ${colorMode}`} aria-label="Submit search" /> */}
    </form>
  );
}

SearchField.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  isSearchVisible: PropTypes.bool,
  setQuery: PropTypes.func.isRequired,
  setIsSearchVisible: PropTypes.func
};

export default SearchField;
